export enum EvaluationFeedbackRequestState {
  PENDING_MANAGER = 'PENDING_MANAGER',
  PENDING_PEER = 'PENDING_PEER',
  DECLINED_MANAGER = 'DECLINED_MANAGER',
  DECLINED_PEER = 'DECLINED_PEER',
  APPROVED = 'APPROVED',
  COMPLETED = 'COMPLETED',
  EXPIRED = 'EXPIRED'
}
